import * as React from 'react';
export const sourcegraphSvg = React.forwardRef(function sourcegraphSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F4F7FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm17.708 14.275 2.648 9.911.989 3.72-4.046 1.089-2.35-8.787-.04-.146-.107.108-6.463 6.45-2.955-2.98 6.433-6.44.106-.108-.146-.04L3 14.708l1.075-4.066 13.633 3.633ZM29 17.285l-1.075 4.066-5.024-1.335a2.106 2.106 0 0 1-1.488-1.489l-.938-3.52L29 17.285Zm-2.387-8.934-3.333 3.336a2.07 2.07 0 0 1-1.477.613h-.076l-1.976-.07h-.001l.055-2.19a2.098 2.098 0 0 1 .617-1.439l3.236-3.231 2.955 2.981Zm-9.637 3.153-3.508-.934a2.104 2.104 0 0 1-1.487-1.49l-1.328-4.994 4.046-1.09 2.277 8.508Z',
      fill: '#FF5543',
    }),
  );
});
sourcegraphSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var sourcegraph = {
  category: 'brand',
  colorable: false,
  name: 'sourcegraph',
  svg: sourcegraphSvg,
};
